export const appName = 'Bem-Estar Ayurveda'
export const practitionerName = 'Patrícia Martins'

export const whatsappNumberDisplay = '+351 939 070 281'
export const whatsappE164 = '+351939070281'
export const whatsappUrl = 'https://wa.me/351939070281'

// Primary conversion action. Points to WhatsApp until an online scheduler
// (Cal.com/Calendly) is chosen — see WIREFRAME.md open questions.
export const bookingUrl = whatsappUrl

export const instagramUrl = 'https://www.instagram.com/bemestar.ayurveda/'
export const siteOrigin = 'https://bemestarayurveda.com'

export const studioName = 'Rebalance Studio'
export const studioMapsUrl = 'https://maps.app.goo.gl/qZk3QeCe6dmYbLBw5'
export const mapsDirectionsUrl =
	'https://www.google.com/maps/dir/?api=1&destination=Rua%201%C2%BA%20de%20Maio%2060%2C%20Ch%C3%A3%2C%203080-847%20Figueira%20da%20Foz'
export const telHref = 'tel:+351939070281'
export const studioStreetAddress = 'Rua 1º de Maio 60, r/c esq., Fração N'
export const studioLocality = 'Chã'
export const studioPostalCode = '3080-847'
export const studioCity = 'Figueira da Foz'
export const studioRegion = 'Coimbra'
export const studioCountry = 'PT'
export const studioLat = 40.1644233
export const studioLng = -8.8294604
export const openingDaysDisplay = '2ª a sábado'

export const studioAddressLine = `${studioStreetAddress}, ${studioLocality}, ${studioPostalCode} ${studioCity}`
export const napLine = `${appName} — ${practitionerName} · ${studioName} · Rua 1º de Maio 60, Chã, 3080-847 Figueira da Foz · ${whatsappNumberDisplay}`
